import { post } from '../index';

export const createAffiliations = (data) => {
  return post(`/invites/user`, data);
};
